var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #33a0ff;\n        stroke-width: 2px;\n        opacity: 0.7;\n      }\n\n      .cls-2 {\n        fill: #33a0ff;\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favorite_icon",
    transform: "translate(-458 -1374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-1",
    transform: "translate(458 1374)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23,
    cy: 23,
    r: 22
  })), /*#__PURE__*/React.createElement("path", {
    id: "hearts",
    className: "cls-2",
    d: "M587,579a3,3,0,0,1,2.24,4.99c-.55.62-5.24,5.01-5.24,5.01s-4.7-4.39-5.25-5.02A2.965,2.965,0,0,1,578,582a3,3,0,0,1,6,0,3,3,0,0,1,3-3m0-2a4.973,4.973,0,0,0-3,1,5,5,0,0,0-6.746,7.3c.562.644,4.261,4.108,5.381,5.154a2,2,0,0,0,2.732,0c1.116-1.045,4.8-4.5,5.369-5.143A5,5,0,0,0,587,577Z",
    transform: "translate(-103.017 813)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite_icon.72cc92b19f4ae56e59f42c050470998a.svg";
export { ForwardRef as ReactComponent };